const collator = new Intl.Collator('de', { numeric: true, sensitivity: 'base' });

/** Natürliche Sortierung: „2.“ vor „10.“, Umlaute korrekt, Groß-/Kleinschreibung egal. */
export function naturalCompare(a: string, b: string): number {
  const r = collator.compare(a, b);
  return r !== 0 ? r : a < b ? -1 : a > b ? 1 : 0;
}

export function naturalSortBy<T>(items: readonly T[], key: (item: T) => string): T[] {
  return [...items].sort((x, y) => naturalCompare(key(x), key(y)));
}
